import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import DatePickers from './DatePicker'
import Time from './Time'
import DropDown from './DropDown'
import ShortText from './ShortText'
import SingleChoice from './SingleChoice'
import LongText from './LongText'
import Number from './Number'

const HeavyMachineryCheckInForm = () => {


    const machineryType =[
        'بیل مکانیکی',
        'بولدوزر',
        'جرثقیل',
        'لودر',
        'لیفتراک',
        'کامیون کمپرسی',
        'گریدر',
    ]


    const conditionOfMachinery = [
        {
            id: 1,
            label: "عالی",
            checked: false
        },
        {
            id: 2,
            label: "خوب",
            checked: false
        },
        {
            id: 3,
            label: "نسبتا خوب",
            checked: false
        },
        {
            id: 4,
            label: "ضعیف",
            checked: false
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ثبت نام ماشین آلات سنگین'} subHeader={'لطفا فرم را برای بررسی ماشین آلات سنگین تکمیل کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <DatePickers header={'تاریخ ورود'} />
                <Time header={'زمان ورود'} />
                <DropDown header={'نوع ماشین آلات'} options={machineryType}/>
                <Number header={'شناسه/شماره سریال ماشین‌آلات'} />
                <SingleChoice header={'وضعیت ماشین آلات'} options={conditionOfMachinery} />
                <LongText header={'نظرات اضافی'} />
            </Grid>
        </Grid>
    )
}

export default HeavyMachineryCheckInForm
